/**
 * Multiplayer countdown widget — DOM port of
 *   packages/amgcommon_v2/lib/widgets/game_timer_widget.dart.
 */
export class GameTimerWidget {
  private readonly host: HTMLElement;
  private readonly el: HTMLElement;
  private readonly labelEl: HTMLElement;
  private readonly secondsEl: HTMLElement;
  private lastSeconds: number | null = null;

  constructor() {
    const host = document.getElementById('dom-hud');
    if (!host) throw new Error('GameTimerWidget: #dom-hud missing');
    this.host = host;

    this.el = document.createElement('div');
    this.el.className = 'mp-timer';

    this.labelEl = document.createElement('div');
    this.labelEl.className = 'mp-timer-label';

    this.secondsEl = document.createElement('div');
    this.secondsEl.className = 'mp-timer-seconds';

    this.el.append(this.labelEl, this.secondsEl);
    this.host.appendChild(this.el);
  }

  showBetTimer(seconds: number | null): void {
    if (seconds === null) {
      this.hide();
      return;
    }
    this.show('BETTING', seconds);
  }

  showRestartTimer(seconds: number | null): void {
    if (seconds === null) {
      this.hide();
      return;
    }
    this.show('NEW ROUND', seconds);
  }

  private show(label: string, seconds: number): void {
    if (label !== this.labelEl.textContent) this.labelEl.textContent = label;
    if (seconds !== this.lastSeconds) {
      this.secondsEl.textContent = String(Math.max(0, Math.floor(seconds)));
      this.lastSeconds = seconds;
    }
    this.el.classList.toggle('urgent', seconds <= 5);
    this.el.classList.add('visible');
  }

  private hide(): void {
    this.el.classList.remove('visible');
    this.el.classList.remove('urgent');
    this.lastSeconds = null;
  }
}
